import { authenticationTypes } from 'root/src/shared/constants/auth';
import { surveyEndpointIds } from 'root/src/shared/survey/constants';
export const ignoreSatisfactionSurveyEndpoint = {
    [surveyEndpointIds.IGNORE_SATISFACTION_SURVEY]: {
        authentication: authenticationTypes.authenticated,
    },
};
